import { ClearOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Input, InputNumber, Space } from 'antd'
import type { FormInstance } from 'antd/es/form'
import { FC } from 'react'
import MaterialTypes from '../../../../components/form-items/material-types/material-types'

interface FilterFormProps {
    form: FormInstance
    onSearch: () => void
    onClear: () => void
}

const FilterForm: FC<FilterFormProps> = ({ form, onSearch, onClear }) => {
    return (
        <Form form={form} component={false} onFieldsChange={onSearch}>
            <Space wrap>
                <Form.Item name='positionId' noStyle>
                    <Input placeholder='№ расчета' allowClear style={{ width: 110 }} />
                </Form.Item>
                <Form.Item name='clientName' noStyle>
                    <Input placeholder='Заказчик' allowClear />
                </Form.Item>
                <Form.Item name='labelName' noStyle>
                    <Input placeholder='Наименование вида' allowClear />
                </Form.Item>
                <MaterialTypes name='materialType' noStyle rules={[]} />
                <Form.Item name='month' noStyle>
                    <DatePicker
                        allowClear
                        picker='month'
                        placeholder='Месяц'
                        format='MM.YYYY'
                        style={{ width: 100 }}
                    />
                </Form.Item>
                <Form.Item name='materialWidth' noStyle>
                    <InputNumber controls={false} placeholder='Ширина' style={{ width: 100 }} />
                </Form.Item>
                <Form.Item name='stampId' noStyle>
                    <Input allowClear placeholder='№ Штампа' style={{ width: 115 }} />
                </Form.Item>
                <Button icon={<ClearOutlined />} title='Сбросить фильтры' onClick={onClear}>
                    Сброс
                </Button>
            </Space>
        </Form>
    )
}

export default FilterForm
